import { create } from 'zustand';

import type { TvParamsMessage } from '~/config/gameParamsMemory';

/**
 * Pont interne, sens inverse de `useRemoteGameParams` : le bridge de l'iframe
 * (useWebViewPlugin) y dépose chaque message `saveGameParams` du jeu chargé sur la
 * TV ; ScreenApp (qui connaît l'établissement et l'écran) l'enregistre sur le compte.
 * File numérotée (les 20 derniers) : deux messages arrivés avant que ScreenApp ne
 * les traite ne doivent pas s'écraser.
 */
export type QueuedGameParams = { id: number; message: TvParamsMessage };

type GameParamsFromGameStore = {
    queue: QueuedGameParams[];
    lastId: number;
    push: (message: TvParamsMessage) => void;
};

export const useGameParamsFromGame = create<GameParamsFromGameStore>((set) => ({
    queue: [],
    lastId: 0,
    push: (message) =>
        set((s) => {
            const id = s.lastId + 1;
            return { lastId: id, queue: [...s.queue, { id, message }].slice(-20) };
        }),
}));
